import { createContext } from 'react';

import { useSearchFormStore } from './SearchFormStore.js';

export const SearchFormContext = createContext<ReturnType<typeof useSearchFormStore> | null>(null);
